import React from 'react';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import oldTracker from 'src/app/api/oldTracker';
import { getIsLoggedIn } from 'src/app/redux/actions/isLoggedIn';
import { feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import rootReducer from 'src/app/redux/reducers';
import rootSaga from 'src/app/redux/sagas';
import RoutesContainer from 'src/app/containers/RoutesContainer';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import alerts from 'src/app/alerts.json';


const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});
const enhancer = composeEnhancers(
  applyMiddleware(sagaMiddleware)
);
const store = createStore(rootReducer, enhancer);
const { replaceReducer, dispatch } = store;

sagaMiddleware.run(rootSaga);
if (module.hot) {
  module.hot.accept('./redux/reducers/index.js', () => {
    // eslint-disable-next-line global-require
    replaceReducer(require('./redux/reducers').default);
  });
}

class App extends React.Component {

  componentWillMount() {
    dispatch(getIsLoggedIn());
  }

  componentDidMount() {
    oldTracker.sendPageView();

    const alert = alerts[getWindowSearchParam('entryFeedback')];

    if (alert) {
      dispatch(feedbackMessageShow(alert));
    }
  }

  render() {
    return (
      <Provider store={ store }>
        <RoutesContainer />
      </Provider>
    );
  }
}

export default hot(module)(App);
